import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeroSection = _resolveComponent("HeroSection")!
  const _component_MediasSection = _resolveComponent("MediasSection")!
  const _component_CineMediasSection = _resolveComponent("CineMediasSection")!
  const _component_NewsSection = _resolveComponent("NewsSection")!
  const _component_RegisterAboutSection = _resolveComponent("RegisterAboutSection")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_HeroSection),
    _createVNode(_component_MediasSection),
    _createVNode(_component_CineMediasSection),
    _createVNode(_component_NewsSection),
    _createVNode(_component_RegisterAboutSection)
  ]))
}